import './HeroStyle.css';
import CV from "../Assets/Rishav.resume.pdf";
import { Link } from 'react-router-dom';
const Hero = (props) => {
    return (
        <div className={props.cName}>
            <img alt="HeroImg" src={props.heroImg} />
            <div className='textCV'>
                <div className="hero-text">
                    <p>{props.text1}</p>
                    <h1>{props.title}</h1>
                    <p>{props.text2}</p>
                </div>
                <div className='cvLink'>
                    <Link to={CV} download target="_blank"><button className='dw-btn'>Download CV</button></Link>
                </div>
            </div>
        </div>
    )
}
export default Hero;